import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import Button from '@mui/material/Button';
import {DeleteForeverRounded, OpenInFullRounded} from "@mui/icons-material";
import { Popconfirm, message, Menu, Dropdown, List, Typography, Checkbox, Modal } from 'antd';
import { selectAllBuilders, clearBuilderState, mergeBuilderStates } from '../../Store/slices/appState.slice';
import { DoubleLine } from "../../Components/Labels";
import { portfolioTypeString } from "../../utils/strings";
import { useBuilder } from "../../Contexts/BuilderContext";
import PercentageAllocator from "../../Components/PercentageAllocator";
import useBuilderDrafts from "./useBuilderDrafts";


const BuilderDrafts = ({ data, selectedRowKeys, handleSelectRow, handleDeleteBuilder, handleOpenDraft }) => (
    <List
        dataSource={data}
        renderItem={(item) => (
            <List.Item
                key={item.key}
                actions={[
                    <Button startIcon={<OpenInFullRounded />} variant={'contained'} onClick={() => handleOpenDraft(item.stateId)}>Open</Button>,
                    <Popconfirm
                        title="Are you sure you want to delete this builder?"
                        onConfirm={() => handleDeleteBuilder(item.stateId)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button startIcon={<DeleteForeverRounded />} variant={'outlined'} color={'error'}>Delete</Button>
                    </Popconfirm>
                ]}
            >
                <Checkbox
                    checked={selectedRowKeys.includes(item.stateId)}
                    onChange={() => handleSelectRow(item.stateId)}
                />
                <List.Item.Meta
                    title={<Typography.Title level={5}>{item.name} ({portfolioTypeString(item.type)})</Typography.Title>}
                    description={<span>{item.items?.length ?? 0} items</span>}
                />
            </List.Item>
        )}
    />
);

const BuilderStatesManager = () => {
    const {
        data,
        selectedRowKeys,
        modalOpen,
        handleOpenDraft,
        handleDeleteBuilder,
        handleDeleteSelected,
        handleMergeSelected,
        onFinishMerge,
        handleSelectRow,
        setModalOpen,
    } = useBuilderDrafts();

    const menu = (
        <Menu>
            <Menu.Item key="1" onClick={handleDeleteSelected} disabled={selectedRowKeys.length === 0}>
                Remove Selected
            </Menu.Item>
            <Menu.Item key="2" onClick={handleMergeSelected} disabled={selectedRowKeys.length < 2}>
                Merge Selected
            </Menu.Item>
        </Menu>
    );

    return (
        <>
            <Dropdown overlay={menu} placement="bottomCenter">
                <Button type="primary" style={{ marginBottom: 16 }}>
                    Actions for Selected
                </Button>
            </Dropdown>
            <BuilderDrafts
                data={data}
                selectedRowKeys={selectedRowKeys}
                handleOpenDraft={handleOpenDraft}
                handleDeleteBuilder={handleDeleteBuilder}
                handleSelectRow={handleSelectRow}
            />
            <Modal open={modalOpen} onOk={() => setModalOpen(false)} onCancel={() => setModalOpen(false)}>
                <PercentageAllocator
                    items={selectedRowKeys.map(key => ({ key, name: data.find(item => item.key === key).name }))}
                    onFinish={onFinishMerge}
                />
            </Modal>
        </>
    );
};

export default BuilderStatesManager;

